import { post } from "../helpers";

const default_key = "datagrid-state";

var lastSavedStateJson = null;

export function customLoad(objectName, key) {
    if (!key)
        key = default_key;

    return post("api/usersettingws/read", { objectName: objectName, key: key }).then((response) => {
        lastSavedStateJson = response.Value;
        var state = JSON.parse(response.Value);

        return state;
    });
}

export function customSave(objectName, state, key) {
    if (!key)
        key = default_key;

    if (state.pageSize <= 0)
        return;

    //todo: uncomment when dataType or format is loaded from translations file
    //state.columns.map((column) => {
    //    delete column.dataType;
    //    delete.column.format;
    //});

    delete state.allowedPageSizes;
    delete state.filterPanel;
    delete state.focusedRowKey;
    delete state.pageIndex;

    if (typeof state.selectedFilterUsFiID === "undefined")
        state.selectedFilterUsFiID = null;

    var stateJson = JSON.stringify(state);
    if (lastSavedStateJson == stateJson)
        return;

    return post("api/usersettingws/write", { objectName: objectName, key: key, value: stateJson });
}